export const testingProjectDescription = ""
//"Assess the dangers of transporting electric cars on ferries"
export const testingCompanyDescription = ""
//"Small Norwegian HSE consulting firm with 10 employees"
